import React, { useEffect, useState } from 'react'
import { Avatar } from 'antd'
import { images } from 'theme'

import {
  CloseOutlined,
  MinusOutlined,
  FullscreenOutlined,
} from '@ant-design/icons'
import styles from './FloatingChat.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import ActiveChatBubble from 'MentalHealth/pages/ActiveChats/views/ActiveChatBubble/ActiveChatBubble'
import AgoraSingleton from 'MentalHealth/components/AudioVideoCallComponent/AgoraSingleton'
import useScopes from 'hooks/useScopes'
import FullPageLoader from '../FullPageLoader'
import { useNavigate } from 'react-router-dom'
import { IoCallOutline } from 'react-icons/io5'
import { CiVideoOn } from 'react-icons/ci'
import { addCurrentSession } from 'slices/mentalHealth.slice'
import { hideModal } from 'slices/modal.slice'
import useAgoraUsers from 'hooks/useAgora'
import { startAgoraCall } from 'slices/manageCall.slice'

const ModalWindow = () => {
  const { currentSession, patientProfile } = useSelector(
    (state) => state.mentalHealth,
  )
  const modalVisible = useSelector((state) => state.modalSlices.visible)
  const dispatch = useDispatch()
  const agoraInstance = AgoraSingleton.getInstance()
  const { setCurrentCallType } = useAgoraUsers()
  const { isCounselor } = useScopes()
  const { me } = useSelector((state) => state.app)
  const [callloading, setCallLoading] = useState(false)

  const navigate = useNavigate()

  const [sessionData, setSessionData] = useState(null)
  const [pageLoading, setPageLoading] = useState(true)

  const handleMaximize = () => {
    console.log(sessionData)
    navigate('/active-chats', { state: { fromDashboard: true } })
    dispatch(addCurrentSession(sessionData))
    dispatch(hideModal())
  }

  useEffect(() => {
    if (isCounselor && currentSession?.doctorID === me?.id) {
      setSessionData(currentSession)
      setPageLoading(false)
    } else if (!currentSession) {
      setPageLoading(false)
    }
  }, [me, currentSession?.patientID, currentSession?.doctorID, isCounselor])

  const onCall = async (callType) => {
    dispatch(startAgoraCall(callType, currentSession, me, patientProfile, agoraInstance, setCallLoading, setCurrentCallType))
  }

  const modalClass = modalVisible
    ? `${styles.modalWindow} ${styles.modalWindowVisible}`
    : `${styles.modalWindow} ${styles.modalWindowHidden}`

  return (
    <div
      className={modalClass}
      style={{ display: modalVisible ? 'flex' : 'none' }}
    >
      {/* Chat topbar */}
      <div className={styles.chatHeader}>
        <div className={styles.chatHeaderInfo}>
          <Avatar src={images.logo} />
          <div className="ml-3">
            <div>{currentSession?.patientName || patientProfile?.userName}</div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Issue:</span>{' '}
              {currentSession?.issue || "other"}
            </div>
          </div>
        </div>
        <div className={styles.chatHeaderActions}>
          <MinusOutlined
            style={{ marginRight: 16 }}
            onClick={() => dispatch(hideModal())}
          />
          <FullscreenOutlined
            style={{ marginRight: 16 }}
            onClick={handleMaximize}
          />
          <CloseOutlined onClick={() => dispatch(hideModal())} />
        </div>
      </div>
      {/* Chat body */}
      <div className={styles.messagesBody}>
        {/* <div className={styles.callBtns}>
          {callloading ? (
            <>
              <FullPageLoader />
            </>
          ) : (<>
            <IoCallOutline
              style={{
                marginRight: 16,
                color: currentSession?.inbox === false ? '#DF7467' : 'inherit',
              }}
              onClick={currentSession?.inbox === true ? null : () => onCall('audioCall')}

            // onClick={() => onCall('audioCall')}
            />
            <CiVideoOn
              style={{
                marginRight: 16,
                color: currentSession?.inbox === false ? '#DF7467' : 'inherit',
              }}
              onClick={currentSession?.inbox === true ? null : () => onCall('videoCall')}

            // onClick={() => onCall('videoCall')}
            />
          </>)}
        </div> */}
        <div className={styles.messageContainer}>
          {pageLoading ? (
            <FullPageLoader />
          ) : !currentSession ? (
            <div>No active chat available</div>
          ) : (
            sessionData && <ActiveChatBubble sessionData={sessionData} />
          )}
        </div>
      </div>
    </div>
  )
}

export default ModalWindow
